module.exports = __webpack_public_path__ + "img/Iron-Horse.59d6ec0a.jpeg";